import { FaRegStar, FaStar, FaStarHalfAlt } from 'react-icons/fa';
import './rating.scss';

function readMessage(messages, path, fallback = '') {
  const resolved = path
    .split('.')
    .reduce((current, segment) => current?.[segment], messages);

  return typeof resolved === 'string' ? resolved : fallback;
}

function getReviewCountLabel(count, ratingLabel) {
  return `${count} ${ratingLabel}`;
}

function getRatingText(value, numReviews, ratingLabel, noReviewsText) {
  const reviewCount = Number(numReviews) || 0;
  const numericValue = Number(value) || 0;

  if (!reviewCount) {
    return noReviewsText;
  }

  return `${numericValue.toFixed(1)} / 5 (${getReviewCountLabel(reviewCount, ratingLabel)})`;
}

export default function Rating({
  value = 0,
  numReviews = 0,
  showText = true,
  className = '',
  messages = {},
  ratingLabel = '',
  noReviewsText = '',
}) {
  const resolvedRatingLabel = readMessage(messages, 'reviews', ratingLabel || 'reviews');
  const resolvedNoReviewsText = readMessage(
    messages,
    'reviews_zero',
    noReviewsText || 'No Reviews Yet',
  );
  const ratingText = getRatingText(
    value,
    numReviews,
    resolvedRatingLabel,
    resolvedNoReviewsText,
  );

  return (
    <div className={`rating ${className}`.trim()} aria-label={ratingText}>
      <div className="rating-stars" aria-hidden="true">
        {[1, 2, 3, 4, 5].map((starNumber) => (
          <span key={starNumber} className="rating-star">
            {value >= starNumber ? (
              <FaStar />
            ) : value >= starNumber - 0.5 ? (
              <FaStarHalfAlt />
            ) : (
              <FaRegStar />
            )}
          </span>
        ))}
      </div>
      {showText ? <p className="rating-text">{ratingText}</p> : null}
    </div>
  );
}
